import RetreatCourseDataStore from '@/data/datastores/RetreatCourseDataStore';

class RetreatCourseDataStoreMock implements RetreatCourseDataStore {
  async registerWithdrawalCourses() {
    return {
      requestId: 5000
    };
  }

  async activateWithdrawalCourses() {
    return {
      requestId: 5001
    };
  }
}

export default RetreatCourseDataStoreMock;
